// extracted by mini-css-extract-plugin
module.exports = {"feedBanner":"feedBanner_feedBanner__VRtBf"};